import React from "react";
import './button.css';

const Button = ({ targetUrl, title = "Learn more", style = { height: '50px', backgroundColor: 'Transparent' } }) =>
    <button onClick={() => window.open(targetUrl, '_blank')} className="bttn-unite bttn-md bttn-danger" style={style}>
        {title}
    </button>
export default Button;


// WEBPACK FOOTER //
// ./src/components/Button.js